const requireComponent = require.context('.', true, /Base[A-Z]\w+\.vue$/);

export default requireComponent.keys().map(fileName => {
    // Get component config
    const componentConfig = requireComponent(fileName)

    // Gets the name regardless of folder depth
    const componentName = fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
        .substring(4);

    return {
        name: componentName,
        config: componentConfig.default || componentConfig
    }
});